import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  suspendPolicies: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the suspendPolicies
export const fetchSuspendPolicies = createAsyncThunk(
  "fetchSuspendPolicies/suspendPolicies",
  async ({ enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`settings/suspend-policies`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create suspendPolicy
export const createSuspendPolicy = createAsyncThunk(
  "createSuspendPolicy/suspendPolicies",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(
        `settings/suspend-policies`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update suspendPolicy
export const updateSuspendPolicy = createAsyncThunk(
  "updateSuspendPolicy/suspendPolicies",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(
        `settings/suspend-policies/${id}`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete suspendPolicy
export const deleteSuspendPolicy = createAsyncThunk(
  "deleteSuspendPolicy/suspendPolicies",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`settings/suspend-policies/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const suspendPolicieslice = createSlice({
  name: "suspendPolicy",
  initialState,
  extraReducers: (builder) => {
    // TODO: create suspendPolicy
    builder.addCase(fetchSuspendPolicies.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSuspendPolicies.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.suspendPolicies = action.payload;
    });

    builder.addCase(fetchSuspendPolicies.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create suspendPolicy
    builder.addCase(createSuspendPolicy.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createSuspendPolicy.fulfilled, (state, action) => {
      state.isLoading = false;
      state.suspendPolicies.data = [
        action.payload.data,
        ...state.suspendPolicies.data,
      ];
      state.suspendPolicies.meta.total = state.suspendPolicies.meta.total + 1;
      action.payload.enqueueSnackbar(
        "Suspend policy is created successfully.",
        {
          variant: "success",
        }
      );
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createSuspendPolicy.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update suspendPolicy
    builder.addCase(updateSuspendPolicy.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateSuspendPolicy.fulfilled, (state, action) => {
      state.isLoading = false;
      state.suspendPolicies.data = state.suspendPolicies.data.map(
        (suspendPolicy) => {
          if (suspendPolicy.id === action.payload.data.id) {
            return action.payload.data;
          } else {
            return suspendPolicy;
          }
        }
      );
      action.payload.enqueueSnackbar(
        "Suspend policy is updated successfully.",
        {
          variant: "success",
        }
      );
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateSuspendPolicy.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete suspendPolicy
    builder.addCase(deleteSuspendPolicy.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteSuspendPolicy.fulfilled, (state, action) => {
      state.isLoading = false;
      state.suspendPolicies.data = state.suspendPolicies.data.filter(
        (suspendPolicy) => suspendPolicy.id !== action.payload.data
      );
      action.payload.enqueueSnackbar(
        "Suspend policy is deleted successfully.",
        {
          variant: "success",
        }
      );
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteSuspendPolicy.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default suspendPolicieslice.reducer;
